




























import AccountServiceHeader from '../organisms/AccountServiceHeader.vue'
import CartHeader from '../organisms/CartHeader.vue'
import EcHeader from '../organisms/EcHeader.vue'
import PlainHeader from '../organisms/PlainHeader.vue'

import AuthHeader from '@/components/organisms/header/AuthHeader.vue'
import { HlAppModeMixin } from '@spa/mixins/hl-app-mode'

import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'

@Component({
  components: {
    'auth-header': AuthHeader,
    'spa-ec-header': EcHeader,
    'spa-plain-header': PlainHeader,
    'spa-cart-header': CartHeader,
    'spa-account-service-header': AccountServiceHeader,
  },
})
export default class DefaultTemplate extends Mixins<HlAppModeMixin>(HlAppModeMixin) {
  @Inject()
  $validator: Validator

  @Prop()
  title: string

  @Prop()
  headerType: {
    type: string,
    required: true,
  }

  @Prop()
  hasNavigation: boolean

  @Prop({ default: '' })
  prevUrl: string

  @Prop({ default: '/' })
  topUrl: string

  created() {
    if (this.hasNavigation) {
      $('.p-navigation__menubar').css('display', 'block')
    } else {
      $('.p-navigation__menubar').css('display', 'none')
    }
  }

  get showHeader(): boolean {
    // ホテラバアプリ用の表示ではヘッダー非表示
    if (this.hlAppMode.isPageForHlApp) {
      return false
    }

    return true
  }
}
